import Root from './Root';
import AddedClientList from './AddedClientList';
import SelectedClientBox from './AddedClientList/ClientBox';
import Body from './Body';
import ClientTabs from './ClientTabs';
import ExistingClient from './ClientTabs/ExistingClient';
import ClientBox from './ClientTabs/ExistingClient/ClientBox';
import NewClient from './ClientTabs/NewClient';
import Footer from './Footer';

export {
  Root,
  Body,
  ClientTabs,
  ExistingClient,
  ClientBox,
  NewClient,
  AddedClientList,
  SelectedClientBox,
  Footer,
};
